import 'config/i18n';
import 'styles/app.less';

import { MonitoringContext } from '@xometry/ui';
import { XTheme } from '@xometry/uikit';
import { getRegionHeaderColor } from 'config/regions/utils';
import { AntThemeProvider } from 'core/ant/AntThemeProvider/AntThemeProvider';
import { ErrorBoundaryWrapper } from 'core/app/ErrorBoundary/ErrorBoundaryWrapper';
import { GQLProvider } from 'core/app/GQLProvider/GQLProvider';
import { RootStoreProvider } from 'core/app/RootStoreProvider/RootStoreProvider';
import { bootstrap } from 'index.utils';
import React from 'react';

import App from './App';

document.documentElement.style.setProperty('--region-header-bg', getRegionHeaderColor());

const overrides = {
  '--x-color-background-summary': '#F0F5FF',
};

void bootstrap(document.getElementById('root')).then(({ root, monitoringClient }) => {
  root.render(
    <MonitoringContext.Provider value={monitoringClient}>
      <XTheme overrides={overrides}>
        <AntThemeProvider>
          <RootStoreProvider>
            <GQLProvider>
              <ErrorBoundaryWrapper>
                <App />
              </ErrorBoundaryWrapper>
            </GQLProvider>
          </RootStoreProvider>
        </AntThemeProvider>
      </XTheme>
    </MonitoringContext.Provider>,
  );
});
